import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  },
  snackbarContent: {
    margin: theme.spacing.unit,
    width: 500
  }
});

export const ErrorBar = ({ messages, onClick, classes }) => {
  if (messages.length > 0) {
    return messages.map((err, index) => (
      <Snackbar
        key={err}
        className={classes.snackbar}
        ContentProps={{
          'aria-describedby': 'message-id',
          message: err,
          className: classes.snackbarContent,
          // style: {
          //   marginTop: (index * 48) + 15,
          //   zIndex: index
          // },
        }}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={() => onClick(index)}
          >
            <CloseIcon />
          </IconButton>
        ]}
        open={messages.length > 0}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={1000}
      />
      )
    );
  }
  return '';
};


export default withStyles(styles)(ErrorBar);



// WEBPACK FOOTER //
// ./src/components/shared/ErrorBar.js